<script lang="ts">
import Modal from './Modal.svelte';
import Button from './Button.svelte';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'primary';
};

let {
  isOpen = false,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'primary'
}: Props = $props();

function handleConfirm() {
  onConfirm();
  onClose();
}

function handleCancel() {
  onClose();
}
</script>

<Modal {isOpen} {onClose} {title} size="sm" showCloseButton={false}>
  {#snippet children()}
    <div class="confirm-message">
      {message}
    </div>
  {/snippet}

  {#snippet footer()}
    <Button variant="ghost" onclick={handleCancel}>
      {cancelText}
    </Button>
    <Button variant={variant} onclick={handleConfirm}>
      {confirmText}
    </Button>
  {/snippet}
</Modal>

<style lang="scss">
.confirm-message {
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  line-height: var(--line-height-relaxed);
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
